module.exports = __webpack_public_path__ + "img/20191026151202493.b774efbb.jpg";